export default __webpack_public_path__ + "media/zurb/img/events/soapbox/amandalinden-df55459cc473854ac6575d3b5a771967.png";